import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { getPostsByLang } from "../data/posts";
import { useLocale } from "../context/LocaleContext";
import "../styles/root.css";
import "../styles/pages.css";

function News() {
  const { lang, t } = useLocale();
  const posts = getPostsByLang(lang);
  const newsItems = [...posts].sort(
    (a, b) => new Date(b.date) - new Date(a.date)
  );

  const revealRefs = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("revealed");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );
    revealRefs.current.forEach((el) => {
      if (el) observer.observe(el);
    });
    return () => observer.disconnect();
  }, [lang]);

  const addRef = (el) => {
    if (el && !revealRefs.current.includes(el)) {
      revealRefs.current.push(el);
    }
  };

  return (
    <div>
      <Navbar />

      <div className="page-hero">
        <div className="page-hero-inner">
          <span className="page-hero-eyebrow">Anisija</span>
          <h1 className="page-hero-title">{t.news.headline}</h1>
          <div className="page-hero-line" />
        </div>
      </div>

      <div className="page-container">
        <div className="news-listing-grid">
          {newsItems.map((post, i) => (
            <article
              className="news-listing-card"
              key={post.slug}
              ref={addRef}
              style={{ "--delay": `${i * 80}ms` }}
            >
              <Link to={`/news/${post.slug}`} className="news-listing-link reveal-up">
                <div className="news-listing-img-wrap">
                  <img
                    className="news-listing-img"
                    src={post.mainImage.src}
                    alt={post.mainImage.alt}
                  />
                </div>
                <div className="news-listing-body">
                  <time className="news-listing-date">
                    {new Date(post.date).toLocaleDateString(
                      lang === "mk" ? "mk-MK" : "en-GB",
                      { year: "numeric", month: "long", day: "numeric" }
                    )}
                  </time>
                  <h2 className="news-listing-title">{post.title}</h2>
                  <p className="news-listing-excerpt">{post.excerpt}</p>
                  <span className="news-listing-read">
                    {t.home.readMore}
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                      <line x1="5" y1="12" x2="19" y2="12" />
                      <polyline points="12 5 19 12 12 19" />
                    </svg>
                  </span>
                </div>
              </Link>
            </article>
          ))}
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default News;
